<div  style="margin-right: 2px;" [ngStyle]="{ 'opacity': disabled ? '0.3' : '1' , 'cursor': disabled ? 'not-allowed' : 'pointer' }" >
  <img *ngIf="icone != null" [src]="'assets/imgs/icons/' + icone + '.svg'" alt="ícone olho" class="mr-2"><span > {{ titulo }}</span>
</div>
